import { Button, IconButton } from "@mui/material";
import { jobOrderColNm } from "constants/jobOrderConstant";
import { ArticleRounded } from "resource/muiImport";

export const columns =[
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
    return (
      <IconButton size="small" >
      <ArticleRounded color="primary"/>
      </IconButton>
    )}
  },
  {
    field: 'No',
    headerName: 'No.',
    width: 30,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'JobOrdId',
    headerName: jobOrderColNm.JobOrdId || 'ใบงาน',
    width: 90,
    renderCell: (params) => <Button variant="outlined" size="small">{params.value}</Button>,
  },
  {
    field: 'JobNo',
    headerName: jobOrderColNm.JobNo || 'JobNo',
    width: 140,
  },
  {
    field: 'Bkg',
    headerName: jobOrderColNm.Bkg || 'Booking',
    width: 140,
  },
  {
    field: 'ContNo',
    headerName: jobOrderColNm.ContNo || 'หมายเลขตู้',
    width: 110,
  },
  {
    field: 'ContSizeFull',
    headerName: jobOrderColNm.ContSizeFull || 'ขนาดตู้',
    width: 80,
  },
  {
    field: 'TakePlc',
    headerName: jobOrderColNm.TakePlc || 'สถานที่รับ',
    width: 80,
  },
  {
    field: 'RtnPlc',
    headerName: jobOrderColNm.RtnPlc || 'สถานที่คืน',
    width: 80,
  },
  {
    field: 'JobSNm',
    headerName: jobOrderColNm.JobSNm || 'ชื่องาน',
    width: 130,
  },
  {
    field: 'PCItemsStr',
    headerName: 'ค่าใช้จ่าย',
    flex: 1,
    minWidth: 150
  }
];
